import type { MobilePlatform } from '../models/Profile';

/** Display label for admin user list App column from `platforms`. */
export function formatMobileAppLabel(
  platforms: MobilePlatform[] | undefined | null,
  mobileAppInstalled?: boolean
): string {
  const set = new Set((platforms ?? []).filter(Boolean));
  const hasIos = set.has('IOS');
  const hasAndroid = set.has('ANDROID');

  if (hasIos && hasAndroid) return 'Both';
  if (hasIos) return 'iOS';
  if (hasAndroid) return 'Android';
  if (mobileAppInstalled) return 'App';
  return '—';
}
